var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"flex flex-col items-center"},[_c('div',{staticClass:"flex gap-0.5 items-end h-6"},[_c('div',{staticClass:"h-1/2 border bg-gray-400 w-1.5 rounded-sm",class:{
        'bg-dodgerblue':
          _vm.level === 'Beginner' ||
          _vm.level === 'Intermediate' ||
          _vm.level === 'Advanced',
      }}),_c('div',{staticClass:"h-3/4 border bg-gray-400 w-1.5 rounded-sm",class:{
        'bg-dodgerblue': _vm.level === 'Intermediate' || _vm.level === 'Advanced',
      }}),_c('div',{staticClass:"h-full border bg-gray-400 w-1.5 rounded-sm",class:{ 'bg-dodgerblue': _vm.level === 'Advanced' }})]),_c('span',{staticClass:"text-sm min-w-max"},[_vm._v(_vm._s(_vm.level))])])}
var staticRenderFns = []

export { render, staticRenderFns }